import { Component, Input, OnInit } from '@angular/core';
import { CacheKey } from '../../../shared/constants/cachekey.constants';
import { State } from '../../../shared/interface/state.interface';
import { CacheService } from '../../../shared/services/cache.service';
import { PurchaseFlow } from '../../common/enumerations';
import { PaymentConstants } from '../../constants/payment.constants';
import { OrderSourceValue } from '../../enums/order-source.enum';
import { PaymentProcessorAlias } from '../../enums/payment-processor-alias.enum';
import { PaymentStatus } from '../../enums/payment-status.enum';
import { ECheckAddress } from '../../interface/eCheck/eCheckAddress.interface';
import { NIRegistration } from '../../interface/networkinternational/networkinternational-registration.interface';
import { NIPaymentService } from '../../interface/networkinternational/networkinternationall-payment-service.interface';
import { PaymentCallBackUrl } from '../../interface/payvision/payment-callback-url.interface';
import { PaymentComponentSettings } from '../../models/payments/payment.model';
import { CustomerService } from '../../services/customer.service';
import { NIService } from '../../services/networkinternational.service';
@Component({
    selector: 'payment-network-international',
    templateUrl: '../../templates/template1/views/payments/networkinternational.component.html',
    styleUrls: []
})

export class NIComponent implements OnInit {
    states: State[] = [];
    @Input() paymentComponentSettings: PaymentComponentSettings;

    constructor(
        private _customerService: CustomerService,
        private _cacheService: CacheService, 
        private _niService: NIService) { }

    ngOnInit(): void {
        this._cacheService.remove(CacheKey.IsRefreshed);
        this.getStates();
    }

/**
 * get States
 */
    getStates() {
        this._customerService.getStates().subscribe(response => {
            if (response) {
                this.states = response;
                this.getNIPaymentForm();
            } else {
                this.getNIPaymentForm();
            }
        }, (error: any) => {
            this.getNIPaymentForm();
        });
    }

    /**
    * @description to get the Payment form
    * @memberof NIComponent
    */
   getNIPaymentForm(): void {
        this._niService
            .getNIForm(this.paymentComponentSettings.storeId, this.getNIRegistrationRequest())
            .subscribe((response) => {
                this.loadNIForm(response);
            });
    }

    /**
    * @description to load the Network international Registration Checkout form
    * @memberof NIComponent
    */
    loadNIForm(registrationResponse): void {
        this._cacheService.set(CacheKey.IsRefreshed, true);
        if (registrationResponse && registrationResponse.paymentUrl) {
                this.paymentComponentSettings.paymentUrl = registrationResponse.paymentUrl;
        }

        setTimeout(() => {
            this.paymentComponentSettings.payvisionFormLoaded = true;
        }, 2000);
    }

    /**
     * @description preparing the network international Registration checkout form request
     * @returns {NIRegistration}
     * @memberof NIComponent
     */
    getNIRegistrationRequest(): NIRegistration {
        const niRegistration: NIRegistration = {
            portalCsp: true,
            countryCode: this.paymentComponentSettings.isoCountryCode.toUpperCase(),
            customerId: this.paymentComponentSettings.memberId ? (+this.paymentComponentSettings.memberId) : 0,
            storeId: this.paymentComponentSettings.storeId,
            orderTypeId: this.paymentComponentSettings.orderTypeId ? this.paymentComponentSettings.orderTypeId
                : PurchaseFlow.Personal_Order,
            orderSourceTypeId: OrderSourceValue.CUSTOMER,
            paymentMethodType: this.paymentComponentSettings.paymentMethodTypes.Credit_Card,
            currencyCode: this.paymentComponentSettings.currencyCode,
            paymentRequestModel: {
                createRegistartion: true,
            },
            billingAddress: this.getBillingAddress(),
            paymentCallBackUrlModel: this.getPaymentCallBackURLModel(),
            paymentServiceModel: this.getPaymentServiceModel()
        };
        return niRegistration;
    }

    /**
     * @description this method will return payment call urls
     * @private
     * @returns {PaymentCallBackUrl}
     * @memberof NIComponent
     */
    private getPaymentCallBackURLModel(): PaymentCallBackUrl {
        const paymentCallBackUrlModel: PaymentCallBackUrl = {
            cancelledUrl: this.getCurrentWindowUrl() + PaymentStatus.CANCELLED.toLowerCase(),
            failureUrl: this.getCurrentWindowUrl() + PaymentStatus.FAILED.toLowerCase(),
            successUrl: this.getCurrentWindowUrl() + PaymentStatus.SUCCESS.toLowerCase(),
            orderSourceTypeId: OrderSourceValue.CUSTOMER,
        };
        return paymentCallBackUrlModel;
    }

    /**
     * @description this method will return network international request model
     * @private
     * @returns {NIPaymentService}
     * @memberof NIComponent
     */
    private getPaymentServiceModel(): NIPaymentService {
        const userEmail: string = this.paymentComponentSettings.memberEmail ? this.paymentComponentSettings.memberEmail : '';
        const paymentServiceModel: NIPaymentService = {
            submit: {
                order: {
                    description: PaymentProcessorAlias.NETWORKINTERNATIONAL,
                    amount: {
                        currencyCode: this.paymentComponentSettings.currencyCode,
                        exponent: this.paymentComponentSettings.numberDecimals
                    },
                    paymentMethodMask: {
                        include: {
                            code: PaymentConstants.paymentMethodMaskCode
                        }
                    },
                    shopper: {
                        shopperEmailAddress: userEmail
                    }
                }
            }
        };
        return paymentServiceModel;
    }

    /**
     * @description this method will return current window url 
     * @private
     * @returns {string}
     * @memberof NIComponent
     */
    private getCurrentWindowUrl(): string {
        const routeURL = window.location.href.includes('posorders') ? '/customerservice/posorders/' : '/customerservice/orders/';
        const currentWindowURL: string = window.location.origin + routeURL
            + PaymentProcessorAlias.NETWORKINTERNATIONAL.toLowerCase() + '/';
        return currentWindowURL;
    }

    /**
    * @description mapping the billing address in the Network International payment form
    * @private
    * @returns {NI BillingAddress}
    * @memberof NIComponent
    */
    private getBillingAddress(): ECheckAddress {
        const code = this.paymentComponentSettings.billingAddress && this.paymentComponentSettings.billingAddress.countryCodeTwo 
                     ?  this.paymentComponentSettings.billingAddress.countryCodeTwo : '';
        const billingAddress: ECheckAddress = {
            countryCode: code ? code : (this.paymentComponentSettings.isoTwoletterCountryCode 
                ? this.paymentComponentSettings.isoTwoletterCountryCode : ''),
            countryCodeTwo: code ? code : (this.paymentComponentSettings.isoTwoletterCountryCode
                ? this.paymentComponentSettings.isoTwoletterCountryCode : ''),
            country: code ? code : (this.paymentComponentSettings.isoTwoletterCountryCode
                ? this.paymentComponentSettings.isoTwoletterCountryCode : ''),
            city: (this.paymentComponentSettings.billingAddress && this.paymentComponentSettings.billingAddress.city)
                ? this.paymentComponentSettings.billingAddress.city.toString() : '',
            state: (this.paymentComponentSettings.billingAddress && this.paymentComponentSettings.billingAddress.stateId)
                ? this.states.find(x => x.id === this.paymentComponentSettings.billingAddress.stateId).stateCode : '',
            postalCode: (this.paymentComponentSettings.billingAddress && this.paymentComponentSettings.billingAddress.zipCode)
                ? this.paymentComponentSettings.billingAddress.zipCode.toString() : '',
            addressLine1: (this.paymentComponentSettings.billingAddress && this.paymentComponentSettings.billingAddress.addressLine1)
                ? this.paymentComponentSettings.billingAddress.addressLine1.toString() : '',
            addressLine2: (this.paymentComponentSettings.billingAddress && this.paymentComponentSettings.billingAddress.addressLine2)
                ? this.paymentComponentSettings.billingAddress.addressLine2.toString() : '',
            addressLine3: (this.paymentComponentSettings.billingAddress && this.paymentComponentSettings.billingAddress.addressLine3)
                ? this.paymentComponentSettings.billingAddress.addressLine3.toString() : '',
        };
        return billingAddress;
    }
}



// WEBPACK FOOTER //
// ./src/app/customerservice/components/payments/networkinternational.component.ts